"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorWithStatus = exports.toStatus = void 0;
const web_log_1 = require("@snapchat/web-log");
function toStatus(statusCode) {
    switch (statusCode) {
        case 400:
            return web_log_1.Status.BadRequest;
        case 451:
            return web_log_1.Status.Unavailable;
        case 404:
            return web_log_1.Status.NotFound;
        case 401:
            return web_log_1.Status.Unauthorized;
        case 410:
            return web_log_1.Status.Gone;
        case 414:
            return web_log_1.Status.UriTooLong;
        case 500:
            return web_log_1.Status.InternalServerError;
        case 503:
            return web_log_1.Status.ServiceUnavailable;
        case 408:
            return web_log_1.Status.RequestTimeout;
        default:
            return web_log_1.Status.Ok;
    }
}
exports.toStatus = toStatus;
class ErrorWithStatus extends Error {
    status;
    props;
    constructor(m, status, props) {
        super(m);
        this.name = "ErrorWithStatus";
        this.status = status;
        this.props = props;
        Error.captureStackTrace(this, ErrorWithStatus);
    }
}
exports.ErrorWithStatus = ErrorWithStatus;
//# sourceMappingURL=statuses.js.map